import { useCallback, useRef, useState } from 'react'
import DocumentHead from '@/components/document-head/DocumentHead'
import DumpsGridMemoed, { IDumpsGridRef } from '@/routes/dumps/DumpsGrid'
import { dump } from '@/model/qsadminapi/QsAdminApiModuleModel'
import DumpPanel from '@/routes/dumps/DumpPanel'
import '../dumps/DumpsPage.scss'
import { useParams } from 'react-router-dom'
import { useScreenSize } from '@/themes/media-query'

const DumpsPage = () => {
  const title = 'Dump'
  const { clientId } = useParams()
  const dumpsGridRef = useRef<IDumpsGridRef>(null)
  const currentScreenSize = useScreenSize()

  const [panelVisible, setPanelVisible] = useState<boolean>(
    JSON.parse(localStorage.getItem(`dump-panel`) ?? '{"visible":false}').visible,
  )
  const [dump, setDump] = useState<dump | null>(JSON.parse(localStorage.getItem(`dump-panel`) ?? '{"dump":null}').dump)
  const [currentFilter, setCurrentFilter] = useState<any[]>(
    clientId ? [['licenza.sede.azienda.id', Number(clientId)]] : [],
  )

  const onPinButtonClick = (value: boolean) => {
    const mainContainer: any = document.querySelector('#dumps-page-main-container')
    const gridContainer: any = document.querySelector('#dump-list')
    const dumpPanelContainer: any = document.querySelector('#dump-panel')

    if (mainContainer && gridContainer && dumpPanelContainer) {
      if (value) {
        const totalWidth = mainContainer.offsetWidth - dumpPanelContainer.offsetWidth
        gridContainer.style.width = `${totalWidth}px`
      } else {
        gridContainer.style.width = mainContainer.style.width
      }
    }
    dumpsGridRef.current?.ref().current?.instance().updateDimensions()
  }

  const onCloseButtonClcik = () => {
    setPanelVisible(false)
    setDump(null)
  }

  const onFocusedRowChanged = (data: dump) => {
    const pinned: boolean = JSON.parse(localStorage.getItem(`dump-panel`) ?? '{"pinned":false}').pinned
    localStorage.setItem(`dump-panel`, JSON.stringify({ visible: true, dump: data, pinned: pinned }))
    if (currentScreenSize.isLarge || currentScreenSize.isMedium) {
      setPanelVisible(true)
      setDump(data)
    }
  }

  return (
    <>
      {!clientId && <h2 className={'content-block'}>{title}</h2>}
      <div id="dumps-page-main-container">
        <div id="dump-list-container" className="view dump-list">
          <div id="dump-list" className="view-wrapper view-wrapper-dump-list">
            <div className={clientId ? '' : 'content-block'}>
              <DumpsGridMemoed
                ref={dumpsGridRef}
                onFocusedRowChanged={onFocusedRowChanged}
                currentFilter={currentFilter}
              ></DumpsGridMemoed>
              {currentScreenSize.isLarge || currentScreenSize.isMedium ? (
                <>
                  <DumpPanel
                    dump={dump}
                    visible={panelVisible}
                    onPinButtonClick={onPinButtonClick}
                    onCloseButtonClcik={onCloseButtonClcik}
                  ></DumpPanel>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DumpsPage
